import React from 'react';
import PropTypes from 'prop-types';
import {I18n, Translate} from 'react-redux-i18n';
import {useLocation} from 'react-router-dom';
import {Paginator} from 'front-onceforall-core';
import ListSearchBar from '../listSearchBar';
import {getSearchValues} from '../../utils/search';
import InviteButton from './button';
import config from '../../../config';

function OrganisationUserListView(props) {
  const location = useLocation();
  const {queryString} = getSearchValues(location.search);
  const [isTyping, setIsTyping] = React.useState(false);

  if (props.error) {
    return <div className="card"><Translate value="error.generic"/></div>;
  }

  return (
    <div className="card">
      <div className="row mt-4">
        <div className="col">
          <ListSearchBar
            onSearch={props.onSearch}
            isTyping={typing => setIsTyping(typing)}
            defaultValue={queryString || ''}
            label={<Translate value="organisation.users.searchLabel"/>}
          />
        </div>
        {config.featureFlags.inviteUser &&
          <div className="col-auto flex-container flex-end pl-4">
            <InviteButton
              onClick={props.onAddClient}
              organisation={props.organisation}
              isSubcontractorView = {props.isSubcontractorView}
            />
          </div>
        }
      </div>
      <div style={{position: 'relative'}}>
        {(props.loading || isTyping) && <div className="loading-overlay"/>}
        {props.users.length === 0 ?
          <div className="table-without-result flex-column">
            <Translate
              value="organisation.users.noResult.line1"
              tag="div"
            />
            {config.featureFlags.inviteUser &&
              <>
                <Translate
                  value="organisation.users.noResult.line2"
                  tag="div"
                />
                <div className="mt-4">
                  <InviteButton
                    onClick={props.onAddClient}
                    organisation={props.organisation}
                    isSubcontractorView = {props.isSubcontractorView}
                  />
                </div>
              </>
            }
          </div> :
          <>
            <table>
              <thead>
                <tr>
                  <td><Translate value="user.role"/></td>
                  <td><Translate value="user.lastName"/></td>
                  <td><Translate value="user.firstName"/></td>
                </tr>
              </thead>
              <tbody>
                {props.users.map((user, index) => (
                  <tr key={`user-${index}`}>
                    <td>{I18n.t(`user.roles.${user.organisationRole}`)}</td>
                    <td>{user.lastName}</td>
                    <td>{user.firstName}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <Paginator
              totalItems={props.totalCount}
              pageSize={props.pageSize}
              currentPage={props.pageNumber}
              onChangePage={props.onPageChange}
            />
          </>
        }
      </div>
    </div>
  );
}

OrganisationUserListView.propTypes = {
  organisation: PropTypes.object.isRequired,
  isSubcontractorView: PropTypes.bool,
  users: PropTypes.array.isRequired,
  onPageChange: PropTypes.func.isRequired,
  pageNumber: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.bool,
  onSearch: PropTypes.func.isRequired,
  onAddClient: PropTypes.func.isRequired
};

export default OrganisationUserListView;
